<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="d_flex_btwn">
        <h1 class="common_title">All Employees</h1>
        <router-link class="btn btn_black" :to="{ name: 'create-user' }"
          >+ Add a New Employee</router-link
        >
      </div>
      <div class="ticket_contact_list_header">
        <div class="d_flex_btwn">
          <div class="order_filter_content">
            <div class="d_flex_start mb_10">
              <input
                type="text"
                class="form_global max_width_200p mr_5"
                placeholder="Employee Name"
                v-on:keyup.enter="searchAgent()"
                v-model="queryParams.name"
              />
              <input
                type="text"
                class="form_global max_width_200p mr_5"
                placeholder="Employee Email"
                v-on:keyup.enter="searchAgent()"
                v-model="queryParams.email"
              />
              <button
                class="btn btn_black mr_5 width_100p pt_10 pb_10"
                @click="
                  queryParams.page = 1;
                  searchAgent();
                "
              >
                Search
              </button>
              <button
                class="btn btn_black width_100p pt_10 pb_10 mr_5"
                @click="resetAll()"
              >
                Reset
              </button>
              <select
                name=""
                class="form_global max_width_200p mr_5"
                v-model="filter.group_id"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="">All Group</option>
                <option
                  v-for="(group, index) in groups"
                  :key="'group_' + index"
                  :value="group.id"
                >
                  {{ group.name }}
                </option>
              </select>
              <select
                name=""
                class="form_global max_width_200p mr_5"
                v-model="sort"
              >
                <option value="1">Name A-Z</option>
                <option value="2">Name Z-A</option>
                <option value="3">Modified</option>
              </select>
              <select
                name=""
                class="form_global max_width_200p mr_5"
                v-model="filter.active"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <select
                name=""
                class="form_global max_width_200p mr_5"
                v-model="filter.verified"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="">All</option>
                <option value="1">Verified</option>
                <option value="0">Unverified</option>
              </select>
              <select
                name=""
                class="form_global max_width_200p"
                v-model="filter.per_page"
                @change="
                  queryParams.page = 1;
                  changeRoute();
                "
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>
          </div>
          <!--                    <div class="d_flex_center">
                        <top-pagination-component 
                            :pagination="pagination"
                            @pageChanged="pageChanged"
                        />
                    </div>-->
        </div>
      </div>
      <div class="vlan_ticket_contact_list_page">
        <div class="vlan_ticket_contact_list_page_wrap">
          <div class="vlan_ticket_contact_list_inner">
            <div class="vlan_ticket_contact_list_inner_wrap">
              <ticket-table-component
                :columns="columns"
                :rows="users"
                :sortable="sortable"
                :pagination="pagination"
                @sorting="sorting"
                @pageChanged="pageChanged"
              >
                <template v-slot:active="{ row }">
                  <div class="form_checkbox">
                    <input
                      type="checkbox"
                      :id="'active_' + row.id"
                      :checked="row.active"
                      :value="row.active"
                    />
                    <label
                      :for="'active_' + row.id"
                      @click.prevent="changeActive($event, row)"
                    ></label>
                  </div>
                </template>

                <template v-slot:verified="{ row }">
                  <div class="form_checkbox">
                    <input
                      type="checkbox"
                      :id="'verified_' + row.id"
                      :checked="row.verified"
                      :value="row.verified"
                    />
                    <label
                      :for="'verified_' + row.id"
                      @click.prevent="changeVerify($event, row)"
                    ></label>
                  </div>
                </template>

                <template v-slot:action="{ row }">
                  <span
                    title="Assign shift"
                    class="pl_15 cursor_pointer"
                    @click.prevent="openModal(row)"
                    ><img src="@/assets/media/images/search2.png" alt=""
                  /></span>
                  <router-link :to="`/user/${row.id}`">
                    <span class="pl_15"
                      ><img src="@/assets/media/images/edit.png" alt=""
                    /></span>
                  </router-link>
                  <span
                    class="pl_15 cursor_pointer"
                    @click.prevent="deleteRecord(row)"
                    ><img src="@/assets/media/images/trash.png" alt=""
                  /></span>
                </template>
              </ticket-table-component>
            </div>
          </div>
        </div>
      </div>
      <shift-assign-modal
        v-if="showModal"
        :showModal="showModal"
        :userData="userData"
        @closeModal="closeModal"
      />
    </div>
  </div>
</template>

<script>
import TicketTableComponent from '@/components/shared/TicketTableComponent';
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import ShiftAssignModal from './ShiftAssignModal.vue';
// import TopPaginationComponent from '../../components/shared/TopPaginationComponent.vue';

// Hoisted so data(), setQueryData() and resetAll() share one definition of
// the unfiltered state: a param missing from the URL has to fall back to its
// default, never to undefined (axios drops those, and a dropped per_page
// makes the API return an unpaginated payload).
const defaultQueryParams = () => ({
  page: 1,
  name: '',
  email: '',
  sort: 'created_at',
  sort_order: 'desc',
  per_page: 20,
});

const defaultFilter = () => ({
  group_id: '',
  active: '',
  verified: '',
  per_page: 20,
});

export default {
  name: 'users',
  components: { LoaderMaskComponent, TicketTableComponent, ShiftAssignModal },
  data() {
    return {
      lyLoading: false,
      users: [],
      sort: '1',
      filter: defaultFilter(),
      queryParams: defaultQueryParams(),
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: 'Employee Name',
          field: 'name',
          sortable: true,
          width: '15%',
        },
        {
          label: 'Employee Email',
          field: 'email',
          sortable: true,
          width: '20%',
        },
        {
          label: 'Employee Group',
          field: 'group.name',
          sortable: false,
        },
        {
          label: 'Created At',
          field: 'created_at',
          sortable: true,
        },
        {
          label: 'Last Login',
          field: 'last_login',
          sortable: true,
        },
        {
          label: 'Active',
          field: 'active',
          sortable: false,
          slot: true,
        },
        {
          label: 'Verified',
          field: 'verified',
          sortable: false,
          slot: true,
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
      update: {
        group_id: '',
        active: '',
        verified: '',
      },
      groups: [],
      showModal: false,
      userData: null,
    };
  },
  created() {
    // Unconditional: partial deep links (?search=x) have to seed state too.
    this.setQueryData(this.getAllQueryParams());
    this.getGroups();
  },
  mounted() {
    if (this.$route.params.group_id) {
      this.filter.group_id = this.$route.params.group_id;
      // this.loadData()
    }
    this.loadData();
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams());
        this.loadData();
      }
    },
    sort() {
      if (this.sort === '1') {
        this.sorting({ column: 'name', order: 'asc' });
      } else if (this.sort === '2') {
        this.sorting({ column: 'name', order: 'desc' });
      } else if (this.sort === '3') {
        this.sorting({ column: 'updated_at', order: 'desc' });
      }
    },
  },
  methods: {
    openModal(row) {
      this.userData = row;
      this.showModal = true;
    },
    closeModal() {
      this.userData = null;
      this.showModal = false;
    },
    setQueryData(query) {
      this.queryParams = this.withQueryDefaults(defaultQueryParams(), query);
      this.filter = this.withQueryDefaults(defaultFilter(), query);

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };
    },
    resetAll() {
      this.queryParams = defaultQueryParams();
      this.filter = defaultFilter();

      this.sortable = {
        order: this.queryParams.sort,
        sort: this.queryParams.sort_order,
      };

      this.changeRoute();
      this.loadData();
    },
    searchAgent() {
      // A new search/filter changes the result set, so the old page number
      // no longer means anything — start from the first page.
      this.queryParams.page = 1;
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    deleteRecord(row) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/users/' + row.id).then(() => {
            this.loadData();
            this.$swal.fire('Deleted', 'Employee has been deleted!', 'success');
          });
        }
      });
    },
    changeActive($e, row) {
      this.update.active = row.active;
      this.axios
        .post('/user/active/' + row.id, this.update)
        .then(() => {
          this.loadData();
          this.showSuccessMsg('Update Successfully!');
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    changeVerify($e, row) {
      this.update.verified = row.verified;
      this.axios
        .post('/user/verified/' + row.id, this.update)
        .then(() => {
          this.loadData();
          this.showSuccessMsg('Update Successfully!');
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    changeMailing($e, row) {
      this.update.mailing_list = row.mailing_list;
      this.axios
        .post('/user/mailing-list/' + row.id, this.update)
        .then(() => {
          this.loadData();
          this.showSuccessMsg('Update Successfully!');
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: { ...this.queryParams, ...this.filter },
      });
    },
    loadData() {
      this.lyLoading = true;
      this.axios
        .get('/users', {
          params: { ...this.queryParams, ...this.filter },
        })
        .then((response) => {
          this.ticketingTableScroll();
          this.users = response.data.data;
          this.pagination = response.data.meta;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    getGroups() {
      this.axios.get('/active-groups-for-relation').then(({ data }) => {
        this.groups = data.data;
      });
    },
    showDownloadFile(filePath) {
      this.filePath = filePath;
      this.showFileModal = true;
    },
    hideFileModal() {
      this.filePath = '';
      this.showFileModal = false;
    },
  },
};
</script>
